<template>
    <div class="container py-5">

        <!-- Cards por Categoria -->
        <div v-if="listByCategory && categoryCards.length" class="nch-presencial-section mb-5">
            <div class="nch-gallery-toolbar pb-3 mb-4">
                <h2 class="section-title text-h5 font-weight-bold mb-0">
                    Galeria de Fotos
                </h2>
            </div>

            <div class="row row-grid">
                <div
                    v-for="cat in categoryCards"
                    :key="cat.id"
                    class="col-xl-3 col-lg-4 col-md-6 col-12 mb-4 d-flex"
                >
                    <div class="nch-presencial-card d-flex flex-column w-100">
                        <div class="nch-presencial-card__media">
                            <img
                                v-if="cat.cover"
                                :src="cat.cover"
                                :alt="cat.name"
                                class="nch-presencial-card__img"
                            />
                            <div v-else class="nch-presencial-card__placeholder">
                                <i class="mdi mdi-image-multiple"></i>
                            </div>
                            <span
                                class="nch-presencial-card__badge"
                                :style="{ backgroundColor: cat.color || 'var(--page-accent, #4caf50)' }"
                            >
                                {{ cat.name }}
                            </span>
                        </div>

                        <div class="nch-presencial-card__body d-flex flex-column flex-grow-1 p-3">
                            <h3 class="nch-presencial-card__title">{{ cat.name }}</h3>
                            <p class="nch-presencial-card__desc text-muted mb-3">
                                {{ cat.galleries.length }} galeria{{ cat.galleries.length !== 1 ? 's' : '' }}
                            </p>

                            <div class="nch-presencial-card__footer mt-auto pt-2">
                                <button
                                    class="nch-presencial-card__btn-photos btn-block"
                                    @click="openCategory(cat.id)"
                                >
                                    <i class="mdi mdi-image-multiple mr-1"></i> Fotos
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Modal: galerias da categoria -->
            <transition name="nch-lb">
                <div v-if="activeCategory && !openGroup" class="nch-gallery-modal" @click.self="closeCategory">
                    <div class="nch-gallery-modal__panel">
                        <div class="nch-gallery-modal__header">
                            <span class="nch-gallery-modal__title">{{ activeCategory.name }}</span>
                            <button class="nch-gallery-modal__close" @click="closeCategory" aria-label="Fechar">
                                <i class="mdi mdi-close"></i>
                            </button>
                        </div>
                        <div class="nch-gallery-modal__body">
                            <div class="nch-gallery-cards">
                                <button
                                    v-for="g in activeCategory.galleries"
                                    :key="g.gallery_id"
                                    class="nch-gallery-card"
                                    @click="openGallery(g.gallery_id)"
                                >
                                    <div class="nch-gallery-card__cover">
                                        <img v-if="g.cover" :src="g.cover" :alt="g.gallery_name" />
                                        <i v-else class="mdi mdi-image-multiple"></i>
                                    </div>
                                    <div class="nch-gallery-card__body">
                                        <span class="nch-gallery-card__title">{{ g.gallery_name || 'Galeria' }}</span>
                                        <span class="nch-gallery-card__count">{{ g.count }} foto{{ g.count !== 1 ? 's' : '' }}</span>
                                    </div>
                                </button>
                            </div>
                            <div v-if="!activeCategory.galleries.length" class="text-center py-6" style="color:var(--page-text-secondary,#9e9e9e)">
                                <i class="mdi mdi-image-off" style="font-size:40px;opacity:.4"></i>
                                <p class="mt-2">Nenhuma galeria nesta categoria.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="listByCategory && !categoryCards.length" class="text-center grey--text py-6">
            <i class="mdi mdi-image-off" style="font-size:48px;opacity:.3"></i>
            <p class="mt-2">Nenhuma categoria com fotos configurada.</p>
        </div>

        <!-- Card mode: grade de galerias -->
        <template v-if="!listByCategory && !listByPlan && cardGalleryMode && groups.length">
            <div class="nch-gallery-cards">
                <button
                    v-for="card in galleryCards"
                    :key="card.gallery_id"
                    class="nch-gallery-card"
                    @click="openGallery(card.gallery_id)"
                >
                    <div class="nch-gallery-card__cover">
                        <img v-if="card.cover" :src="card.cover" :alt="card.gallery_name" />
                        <i v-else class="mdi mdi-image-multiple"></i>
                    </div>
                    <div class="nch-gallery-card__body">
                        <span class="nch-gallery-card__title">{{ card.gallery_name || 'Galeria' }}</span>
                        <span class="nch-gallery-card__count">{{ card.count }} foto{{ card.count !== 1 ? 's' : '' }}</span>
                    </div>
                </button>
            </div>
        </template>

        <!-- Cards por Plano -->
        <div v-if="listByPlan && planCards.length" class="nch-presencial-section mb-5">
            <!-- Filtro de planos (paridade com /plans e plans_filter) -->
            <div class="nch-plan-filter-bleed mb-4">
                <Search
                    v-model="planType"
                    :categories="categories"
                    :plan-categories="selectedCategories"
                    :plan-facets="[]"
                    :selected-facets="selectedFacets"
                    :available-years="availableYears"
                    :selected-year="selectedYear"
                    :currency="false"
                    :show-search="false"
                    no-fixed
                    @searchInput="onPlanSearch"
                    @categoryFilter="onCategoryFilter"
                    @facetFilter="onFacetFilter"
                    @yearFilter="onYearFilter"
                    @cleanFilter="cleanPlanFilter"
                />
            </div>

            <div class="row row-grid">
                <div
                    v-for="plan in filteredPlanCards"
                    :key="plan.id"
                    class="col-xl-3 col-lg-4 col-md-6 col-12 mb-4 d-flex"
                >
                    <div class="nch-presencial-card d-flex flex-column w-100">
                        <div class="nch-presencial-card__media">
                            <img
                                v-if="plan.cover"
                                :src="plan.cover"
                                :alt="plan.name"
                                class="nch-presencial-card__img"
                            />
                            <div v-else class="nch-presencial-card__placeholder">
                                <i class="mdi mdi-image-multiple"></i>
                            </div>
                            <span
                                class="nch-presencial-card__badge"
                                :style="{ backgroundColor: plan.color || 'var(--page-accent, #4caf50)' }"
                            >
                                {{ plan.name }}
                            </span>
                        </div>

                        <div class="nch-presencial-card__body d-flex flex-column flex-grow-1 p-3">
                            <h3 class="nch-presencial-card__title">{{ plan.name }}</h3>
                            <p class="nch-presencial-card__desc text-muted mb-3">
                                {{ plan.galleries.length }} galeria{{ plan.galleries.length !== 1 ? 's' : '' }}
                            </p>

                            <div class="nch-presencial-card__footer mt-auto pt-2">
                                <button
                                    class="nch-presencial-card__btn-photos btn-block"
                                    @click="openPlan(plan.id)"
                                >
                                    <i class="mdi mdi-image-multiple mr-1"></i> Fotos
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!filteredPlanCards.length" class="text-center py-6" style="color:var(--page-text-secondary,#9e9e9e)">
                <i class="mdi mdi-magnify-remove-outline" style="font-size:48px;opacity:.4"></i>
                <p class="mt-2">Nenhum plano encontrado para o filtro.</p>
            </div>

            <!-- Modal: galerias do plano -->
            <transition name="nch-lb">
                <div v-if="activePlan && !openGroup" class="nch-gallery-modal" @click.self="closePlan">
                    <div class="nch-gallery-modal__panel">
                        <div class="nch-gallery-modal__header">
                            <span class="nch-gallery-modal__title">{{ activePlan.name }}</span>
                            <button class="nch-gallery-modal__close" @click="closePlan" aria-label="Fechar">
                                <i class="mdi mdi-close"></i>
                            </button>
                        </div>
                        <div class="nch-gallery-modal__body">
                            <div class="nch-gallery-cards">
                                <button
                                    v-for="g in activePlan.galleries"
                                    :key="g.gallery_id"
                                    class="nch-gallery-card"
                                    @click="openGallery(g.gallery_id)"
                                >
                                    <div class="nch-gallery-card__cover">
                                        <img v-if="g.cover" :src="g.cover" :alt="g.gallery_name" />
                                        <i v-else class="mdi mdi-image-multiple"></i>
                                    </div>
                                    <div class="nch-gallery-card__body">
                                        <span class="nch-gallery-card__title">{{ g.gallery_name || 'Galeria' }}</span>
                                        <span class="nch-gallery-card__count">{{ g.count }} foto{{ g.count !== 1 ? 's' : '' }}</span>
                                    </div>
                                </button>
                            </div>
                            <div v-if="!activePlan.galleries.length" class="text-center py-6" style="color:var(--page-text-secondary,#9e9e9e)">
                                <i class="mdi mdi-image-off" style="font-size:40px;opacity:.4"></i>
                                <p class="mt-2">Nenhuma galeria neste plano.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="listByPlan && !planCards.length" class="text-center grey--text py-6">
            <i class="mdi mdi-image-off" style="font-size:48px;opacity:.3"></i>
            <p class="mt-2">Nenhum plano com fotos configurado.</p>
        </div>

        <!-- Modal da galeria aberta (compartilhado: categoria + card mode) -->
        <transition name="nch-lb">
                <div v-if="openGroup" class="nch-gallery-modal" @click.self="closeGallery">
                    <div class="nch-gallery-modal__panel">
                        <div class="nch-gallery-modal__header">
                            <button
                                v-if="activeCategory || activePlan"
                                class="nch-gallery-modal__close mr-2"
                                @click="closeGallery"
                                aria-label="Voltar"
                            >
                                <i class="mdi mdi-arrow-left"></i>
                            </button>
                            <span class="nch-gallery-modal__title">{{ openGroup.gallery_name }}</span>
                            <button class="nch-gallery-modal__close" @click="closeGalleryAll" aria-label="Fechar">
                                <i class="mdi mdi-close"></i>
                            </button>
                        </div>

                        <div class="nch-gallery-modal__filters">
                            <div class="nch-gallery-search">
                                <i class="fas fa-search nch-gallery-search__icon"></i>
                                <input
                                    v-model="gallerySearch"
                                    class="nch-gallery-search__input"
                                    type="text"
                                    placeholder="Buscar por data (2024, 05/2024, 15/05/2024)..."
                                    autocomplete="off"
                                />
                                <button v-if="gallerySearch" class="nch-gallery-search__clear" @click="gallerySearch = ''">
                                    <i class="mdi mdi-close"></i>
                                </button>
                            </div>
                        </div>

                        <div class="nch-gallery-modal__body">
                            <div
                                class="nch-gallery"
                                :style="{ '--cols': columns, '--gallery-gap': gapPx }"
                            >
                                <div
                                    v-for="(img, li) in modalImages"
                                    :key="img.id"
                                    class="nch-gallery__item"
                                    @click="lightbox && openModalLightbox(li)"
                                    :style="lightbox ? { cursor: 'pointer' } : {}"
                                >
                                    <div class="nch-gallery__media">
                                        <img :src="img.thumb" :alt="img.name" class="nch-gallery__img nch-gallery__img--loaded" />
                                    </div>
                                </div>
                            </div>
                            <div v-if="!modalImages.length" class="text-center py-6" style="color:var(--page-text-secondary,#9e9e9e)">
                                <i class="mdi mdi-magnify-remove-outline" style="font-size:40px;opacity:.4"></i>
                                <p class="mt-2">Nenhum resultado.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>

        <!-- Legacy mode: toolbar + sections -->
        <template v-if="!listByCategory && !listByPlan && !cardGalleryMode">

        <!-- Search / section filter (only when has content) -->
        <div v-if="groups.length" class="nch-gallery-toolbar">
            <!-- Text search (filters section names) -->
            <div class="nch-gallery-search">
                <i class="fas fa-search nch-gallery-search__icon"></i>
                <input
                    v-model="gallerySearch"
                    class="nch-gallery-search__input"
                    type="text"
                    placeholder="Buscar seção ou data (2024, 05/2024, 15/05/2024)..."
                    autocomplete="off"
                />
                <button v-if="gallerySearch" class="nch-gallery-search__clear" @click="gallerySearch = ''">
                    <i class="mdi mdi-close"></i>
                </button>
            </div>

            <!-- Section filter chips (only with multiple sections) -->
            <div v-if="groups.length > 1" class="nch-gallery-filters">
                <button
                    class="nch-gallery-filter-chip"
                    :class="{ 'nch-gallery-filter-chip--active': activeSection === null }"
                    @click="activeSection = null"
                >Todas</button>
                <button
                    v-for="group in groups"
                    :key="group.gallery_id"
                    class="nch-gallery-filter-chip"
                    :class="{ 'nch-gallery-filter-chip--active': activeSection === group.gallery_id }"
                    @click="activeSection = activeSection === group.gallery_id ? null : group.gallery_id"
                >
                    {{ group.gallery_name }}
                    <span class="nch-gallery-filter-count">{{ group.images.length }}</span>
                </button>
            </div>
        </div>

        <div v-if="!groups.length" class="text-center grey--text py-6">
            <i class="mdi mdi-image-off" style="font-size:48px;opacity:.3"></i>
            <p class="mt-2">Nenhuma imagem encontrada.</p>
        </div>
        <div v-else-if="filteredGroups.length === 0" class="text-center py-6" style="color:var(--page-text-secondary,#9e9e9e)">
            <i class="mdi mdi-magnify-remove-outline" style="font-size:48px;opacity:.4"></i>
            <p class="mt-2">Nenhum resultado para "<strong>{{ gallerySearch }}</strong>"</p>
            <p class="caption mt-1" style="opacity:.6">Busque por nome da seção ou data (ex: 2024, 05/2024, 15/05/2024)</p>
        </div>

        <template v-else>
            <div
                v-for="(group, gi) in filteredGroups"
                :key="group.gallery_id"
                class="nch-gallery-section"
                :class="{ 'nch-gallery-section--spaced': gi > 0 }"
            >
                <div v-if="showTitles && groups.length > 1" class="nch-gallery-section__header">
                    <span class="nch-gallery-section__title">{{ group.gallery_name }}</span>
                    <span class="nch-gallery-section__count">{{ group.images.length }} foto{{ group.images.length !== 1 ? 's' : '' }}</span>
                </div>

                <div
                    class="nch-gallery"
                    :class="{ 'nch-gallery--cards': cardLayout }"
                    :style="{ '--cols': columns, '--gallery-gap': gapPx }"
                >
                    <div
                        v-for="(img, li) in visibleImages(gi)"
                        :key="img.id"
                        class="nch-gallery__item"
                        :class="{ 'nch-gallery__item--card': cardLayout }"
                        :data-global="globalIndex(gi, li)"
                        @click="lightbox && openLightbox(globalIndex(gi, li))"
                        :style="lightbox ? { cursor: 'pointer' } : {}"
                    >
                        <div class="nch-gallery__media">
                            <div
                                class="nch-gallery__shimmer"
                                :class="{ 'nch-gallery__shimmer--done': imgLoaded[globalIndex(gi, li)] }"
                            ></div>
                            <img
                                v-if="observed[globalIndex(gi, li)]"
                                :src="img.thumb"
                                :alt="img.name || (group.gallery_name + ' ' + (li + 1))"
                                class="nch-gallery__img"
                                :class="{ 'nch-gallery__img--loaded': imgLoaded[globalIndex(gi, li)] }"
                                @load="imgLoaded[globalIndex(gi, li)] = true"
                                @error="imgLoaded[globalIndex(gi, li)] = true"
                            />
                        </div>
                        <div v-if="cardLayout && showCaptions" class="nch-gallery__caption">
                            <span class="nch-gallery__caption-name">{{ img.name || ('Foto ' + (li + 1)) }}</span>
                            <span v-if="img.created_at" class="nch-gallery__caption-date">{{ formatDate(img.created_at) }}</span>
                        </div>
                    </div>
                </div>

                <!-- Load more button -->
                <div
                    v-if="hasMore(gi)"
                    class="nch-gallery__load-more"
                >
                    <button class="nch-gallery__load-btn" @click="loadMore(gi)">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style="margin-right:6px" aria-hidden="true">
                            <path d="M8 3v10M3 8l5 5 5-5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        Ver mais {{ remainingCount(gi) }} foto{{ remainingCount(gi) !== 1 ? 's' : '' }}
                    </button>
                </div>
            </div>
        </template>

        </template><!-- end legacy mode -->

        <transition name="nch-lb">
            <div
                v-if="lightbox && lightboxOpen"
                class="nch-lightbox"
                @click.self="closeLightbox"
            >
                <button class="nch-lightbox__close" @click="closeLightbox" aria-label="Fechar">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
                        <path d="M1.5 1.5l15 15M16.5 1.5l-15 15" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>
                    </svg>
                </button>

                <button
                    v-if="allImages.length > 1"
                    class="nch-lightbox__nav nch-lightbox__nav--prev"
                    @click.stop="prevImage"
                    aria-label="Imagem anterior"
                >
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">
                        <path d="M14 17l-6-6 6-6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>

                <transition name="nch-lb-slide" mode="out-in">
                    <img
                        v-if="lightboxIndex !== null"
                        :key="lightboxIndex"
                        :src="allImages[lightboxIndex].url"
                        class="nch-lightbox__img"
                        :alt="allImages[lightboxIndex].sectionName"
                    />
                </transition>

                <button
                    v-if="allImages.length > 1"
                    class="nch-lightbox__nav nch-lightbox__nav--next"
                    @click.stop="nextImage"
                    aria-label="Próxima imagem"
                >
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">
                        <path d="M8 5l6 6-6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>

                <div class="nch-lightbox__meta">
                    <span v-if="lightboxIndex !== null && groups.length > 1" class="nch-lightbox__section-label">
                        {{ allImages[lightboxIndex].sectionName }}
                    </span>
                    <span v-if="allImages.length > 1" class="nch-lightbox__counter">
                        {{ lightboxIndex + 1 }} / {{ allImages.length }}
                    </span>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import Search from '../Search';
import debounce from '../../helpers/helpers';

export default {
    name: 'GalleryPage',

    components: {
        Search,
    },

    props: {
        config: { type: Object, default: () => ({}) },
        images: { type: Array, default: () => [] },
        categoryGalleries: { type: Array, default: () => [] },
        planGalleries: { type: Array, default: () => [] },
        categories: { type: Array, default: () => [] },
        planFacets: { type: Array, default: () => [] },
        availableYears: { type: Array, default: () => [] },
        pageColor: {
            type: Object,
            default: () => ({ primary: '', secondary: '' }),
        },
    },

    data() {
        return {
            lightboxIndex: null,
            lightboxOpen: false,
            observed: {},
            imgLoaded: {},
            observer: null,
            sectionLoaded: {},
            gallerySearch: '',
            activeSection: null,
            openGalleryId: null,
            openCategoryId: null,
            openPlanId: null,
            // Filtro de planos (modo plano) — paridade com /plans e plans_filter
            planSearch: '',
            planType: [],
            selectedCategories: [],
            selectedFacets: {},
            selectedYear: '',
            filteredPlanIds: null, // null = sem filtro (mostra todos)
        };
    },

    computed: {
        color() {
            return this.$store.getters.COLOR || {};
        },
        columns() {
            return this.config.columns || 3;
        },
        lightbox() {
            return this.config.lightbox !== false;
        },
        showTitles() {
            return this.config.show_section_titles !== false;
        },
        perPage() {
            return this.config.per_page || 20;
        },
        gapPx() {
            return (this.config.gap || 10) + 'px';
        },
        cardLayout() {
            return this.config.card_layout === true;
        },
        showCaptions() {
            return this.config.show_captions !== false;
        },
        cardGalleryMode() {
            return this.config.gallery_card_mode === true;
        },
        galleryCards() {
            return this.groups.map(g => ({
                gallery_id: g.gallery_id,
                gallery_name: g.gallery_name,
                count: g.images.length,
                cover: g.images.length ? g.images[0].thumb : null,
            }));
        },
        openGroup() {
            if (this.openGalleryId === null) return null;
            return this.groups.find(g => g.gallery_id === this.openGalleryId) || null;
        },
        modalImages() {
            if (!this.openGroup) return [];
            const q = this.gallerySearch.trim().toLowerCase();
            if (!q) return this.openGroup.images;
            const isDateQuery = /^[\d\/\-]+$/.test(this.gallerySearch.trim());
            if (!isDateQuery) return this.openGroup.images;
            const normalized = q
                .replace(/^(\d{2})\/(\d{2})\/(\d{4})$/, '$3-$2-$1')
                .replace(/^(\d{2})\/(\d{4})$/, '$2-$1');
            return this.openGroup.images.filter(img => img.created_at && img.created_at.includes(normalized));
        },
        modalGlobalOffset() {
            if (!this.openGroup) return 0;
            let offset = 0;
            for (const g of this.groups) {
                if (g.gallery_id === this.openGroup.gallery_id) break;
                offset += g.images.length;
            }
            return offset;
        },

        groups() {
            if (!this.images || !this.images.length) return [];
            if (this.images[0] && this.images[0].images) return this.images;
            return [{ gallery_id: 0, gallery_name: '', images: this.images }];
        },

        allImages() {
            return this.groups.flatMap((g) =>
                g.images.map((img) => ({ ...img, sectionName: g.gallery_name }))
            );
        },

        filteredGroups() {
            let result = this.groups;

            // Filter by section chip
            if (this.activeSection !== null) {
                result = result.filter(g => g.gallery_id === this.activeSection);
            }

            const q = this.gallerySearch.trim().toLowerCase();
            if (!q) return result;

            // Date search: "2024", "2024-05", "15/05/2024", "05/2024"
            const isDateQuery = /^[\d\/\-]+$/.test(this.gallerySearch.trim());

            return result
                .map(g => {
                    // Try section name match first
                    if (g.gallery_name.toLowerCase().includes(q)) return g;

                    // Filter images within group by date
                    if (isDateQuery) {
                        const filtered = g.images.filter(img => {
                            if (!img.created_at) return false;
                            // Normalize: "15/05/2024" → "2024-05-15", "05/2024" → "2024-05"
                            const normalized = q
                                .replace(/^(\d{2})\/(\d{2})\/(\d{4})$/, '$3-$2-$1')
                                .replace(/^(\d{2})\/(\d{4})$/, '$2-$1');
                            return img.created_at.includes(normalized);
                        });
                        if (filtered.length) return { ...g, images: filtered };
                    }
                    return null;
                })
                .filter(Boolean);
        },

        listByCategory() {
            return this.config.list_by_category === true;
        },

        // Categoria → pastas (mapa da config), só categorias com pastas que têm fotos
        categoryCards() {
            if (!this.categoryGalleries) return [];
            return this.categoryGalleries.map(cat => {
                const galleries = (cat.gallery_ids || [])
                    .map(gid => this.groups.find(g => Number(g.gallery_id) === Number(gid)))
                    .filter(Boolean)
                    .map(g => ({
                        gallery_id: g.gallery_id,
                        gallery_name: g.gallery_name,
                        count: g.images.length,
                        cover: g.images.length ? g.images[0].thumb : null,
                    }));
                return {
                    id: cat.id,
                    name: cat.name,
                    color: cat.color,
                    galleries,
                    cover: galleries.length ? galleries[0].cover : null,
                };
            }).filter(c => c.galleries.length);
        },

        activeCategory() {
            if (this.openCategoryId === null) return null;
            return this.categoryCards.find(c => c.id === this.openCategoryId) || null;
        },

        listByPlan() {
            return this.config.list_by_plan === true;
        },

        // Plano → pastas (mapa da config), só planos com pastas que têm fotos
        planCards() {
            if (!this.planGalleries) return [];
            return this.planGalleries.map(plan => {
                const galleries = (plan.gallery_ids || [])
                    .map(gid => this.groups.find(g => Number(g.gallery_id) === Number(gid)))
                    .filter(Boolean)
                    .map(g => ({
                        gallery_id: g.gallery_id,
                        gallery_name: g.gallery_name,
                        count: g.images.length,
                        cover: g.images.length ? g.images[0].thumb : null,
                    }));
                return {
                    id: plan.id,
                    name: plan.name,
                    color: plan.color,
                    cover: plan.cover || (galleries.length ? galleries[0].cover : null),
                    galleries,
                };
            }).filter(p => p.galleries.length);
        },

        activePlan() {
            if (this.openPlanId === null) return null;
            return this.planCards.find(p => p.id === this.openPlanId) || null;
        },

        // Facetas exibíveis no filtro (só as com valores)
        visibleFacets() {
            return (this.planFacets || [])
                .filter(f => f && f.key && Array.isArray(f.values) && f.values.length);
        },

        showPlanFilter() {
            return this.listByPlan && this.planCards.length > 0;
        },

        hasPlanFilters() {
            return !!this.planSearch
                || this.planType.length > 0
                || this.selectedCategories.length > 0
                || Object.keys(this.selectedFacets).length > 0
                || !!this.selectedYear;
        },

        // Cards do plano após aplicar o filtro (intersecção com ids da API)
        filteredPlanCards() {
            if (this.filteredPlanIds === null) return this.planCards;
            const ids = this.filteredPlanIds;
            return this.planCards.filter(p => ids.includes(Number(p.id)));
        },
    },

    watch: {
        planSearch() { debounce(() => this.fetchFilteredPlans(), 400).call(); },
        planType() { debounce(() => this.fetchFilteredPlans(), 300).call(); },
        selectedCategories() { debounce(() => this.fetchFilteredPlans(), 300).call(); },
        selectedFacets: { deep: true, handler() { debounce(() => this.fetchFilteredPlans(), 300).call(); } },
        selectedYear() { debounce(() => this.fetchFilteredPlans(), 300).call(); },
        images(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.observed = {};
                this.imgLoaded = {};
                this.sectionLoaded = {};
                if (this.observer) {
                    this.observer.disconnect();
                    this.observer = null;
                }
                this.$nextTick(this.setupObserver);
            }
        },
    },

    mounted() {
        this.$nextTick(this.setupObserver);
        window.addEventListener('keydown', this.onKeydown);
    },

    beforeUnmount() {
        if (this.observer) this.observer.disconnect();
        window.removeEventListener('keydown', this.onKeydown);
        document.body.style.overflow = '';
    },

    methods: {
        openCategory(id) {
            this.openCategoryId = id;
            document.body.style.overflow = 'hidden';
        },
        closeCategory() {
            this.openCategoryId = null;
            document.body.style.overflow = '';
        },

        openPlan(id) {
            this.openPlanId = id;
            document.body.style.overflow = 'hidden';
        },
        closePlan() {
            this.openPlanId = null;
            document.body.style.overflow = '';
        },

        // ── Filtro de planos (modo plano) ──
        onPlanSearch(value) { this.planSearch = value; },
        onCategoryFilter(cats) { this.selectedCategories = (cats || []).filter(c => c); },
        onFacetFilter(facets) { this.selectedFacets = facets; },
        onYearFilter(year) { this.selectedYear = year; },
        cleanPlanFilter() {
            this.planSearch = '';
            this.planType = [];
            this.selectedCategories = [];
            this.selectedFacets = {};
            this.selectedYear = '';
            this.filteredPlanIds = null;
        },
        fetchFilteredPlans() {
            // Sem filtro ativo → mostra todos os cards configurados
            if (!this.hasPlanFilters) {
                this.filteredPlanIds = null;
                return;
            }
            const iso = (this.$store.getters.LANGUAGE && this.$store.getters.LANGUAGE.iso) || 'pt-br';
            const currency = this.$store.getters.CURRENCY || {};
            window.axios.get(`/api/public/plans/${iso}/200`, {
                params: {
                    page: 1,
                    column: 'plans.id',
                    order: 'ASC',
                    currency: currency.code || null,
                    type: this.planType.length ? this.planType : null,
                    categories: this.selectedCategories.length ? this.selectedCategories : null,
                    facets: Object.keys(this.selectedFacets).length ? this.selectedFacets : null,
                    year: this.selectedYear || null,
                    search: this.planSearch,
                },
            }).then(res => {
                const list = (res.data && res.data.data) || [];
                this.filteredPlanIds = list.map(p => Number(p.id));
            }).catch(err => {
                console.error(err);
                this.filteredPlanIds = null;
            });
        },

        formatDate(dateStr) {
            if (!dateStr) return '';
            const parts = dateStr.split('-');
            if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
            return dateStr;
        },

        visibleImages(gi) {
            const pages = this.sectionLoaded[gi] || 1;
            return this.groups[gi].images.slice(0, pages * this.perPage);
        },

        hasMore(gi) {
            const pages = this.sectionLoaded[gi] || 1;
            return this.groups[gi].images.length > pages * this.perPage;
        },

        remainingCount(gi) {
            const pages = this.sectionLoaded[gi] || 1;
            const shown = pages * this.perPage;
            return Math.min(this.perPage, this.groups[gi].images.length - shown);
        },

        loadMore(gi) {
            const current = this.sectionLoaded[gi] || 1;
            this.sectionLoaded[gi] = current + 1;
            this.$nextTick(this.reobserveNew);
        },

        globalIndex(groupIdx, localIdx) {
            let offset = 0;
            for (let i = 0; i < groupIdx; i++) {
                offset += this.groups[i].images.length;
            }
            return offset + localIdx;
        },

        setupObserver() {
            if (!this.allImages.length) return;

            if (!('IntersectionObserver' in window)) {
                this.allImages.forEach((_, i) => { this.observed[i] = true; });
                return;
            }

            this.observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            const i = parseInt(entry.target.dataset.global, 10);
                            if (!isNaN(i)) {
                                this.observed[i] = true;
                                this.observer.unobserve(entry.target);
                            }
                        }
                    });
                },
                { rootMargin: '200px 0px' }
            );

            this.$el.querySelectorAll('.nch-gallery__item').forEach((el) => {
                this.observer.observe(el);
            });
        },

        reobserveNew() {
            if (!this.observer) return;
            this.$el.querySelectorAll('.nch-gallery__item:not([data-observed])').forEach((el) => {
                el.setAttribute('data-observed', '1');
                this.observer.observe(el);
            });
        },

        openLightbox(globalIdx) {
            this.lightboxIndex = globalIdx;
            this.lightboxOpen = true;
            document.body.style.overflow = 'hidden';
        },

        closeLightbox() {
            this.lightboxOpen = false;
            if (this.openGalleryId !== null) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
            setTimeout(() => { this.lightboxIndex = null; }, 280);
        },

        openGallery(id) {
            this.openGalleryId = id;
            this.gallerySearch = '';
            document.body.style.overflow = 'hidden';
        },
        closeGallery() {
            // Volta pra lista de galerias da categoria (se aberta), senão fecha tudo
            this.openGalleryId = null;
            this.gallerySearch = '';
            if (this.openCategoryId === null && this.openPlanId === null) {
                document.body.style.overflow = '';
            }
        },
        closeGalleryAll() {
            this.openGalleryId = null;
            this.openCategoryId = null;
            this.openPlanId = null;
            this.gallerySearch = '';
            document.body.style.overflow = '';
        },
        openModalLightbox(localIdx) {
            this.lightboxIndex = this.modalGlobalOffset + localIdx;
            this.lightboxOpen = true;
            document.body.style.overflow = 'hidden';
        },

        prevImage() {
            this.lightboxIndex = (this.lightboxIndex - 1 + this.allImages.length) % this.allImages.length;
        },

        nextImage() {
            this.lightboxIndex = (this.lightboxIndex + 1) % this.allImages.length;
        },

        onKeydown(e) {
            if (this.lightboxOpen) {
                if (e.key === 'Escape') this.closeLightbox();
                if (e.key === 'ArrowLeft' && this.allImages.length > 1) this.prevImage();
                if (e.key === 'ArrowRight' && this.allImages.length > 1) this.nextImage();
                return;
            }
            if (this.openGalleryId !== null && e.key === 'Escape') { this.closeGallery(); return; }
            if (this.openCategoryId !== null && e.key === 'Escape') { this.closeCategory(); return; }
            if (this.openPlanId !== null && e.key === 'Escape') this.closePlan();
        },
    },
};
</script>

<style scoped>
/* Filtro de planos full-bleed (igual à página de palestras) */
.nch-plan-filter-bleed {
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    margin-top: -3rem; /* elimina o espaço branco do padding-top do container */
}

/* ── Gallery toolbar ── */
.nch-gallery-toolbar {
    padding: 16px 0 12px;
    border-bottom: 1px solid var(--page-border, rgba(0,0,0,0.08));
    margin-bottom: 24px;
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    align-items: center;
}

.nch-gallery-search {
    position: relative;
    display: flex;
    align-items: center;
    background: var(--page-surface, #f5f5f5);
    border: 1.5px solid var(--page-border, #e0e0e0);
    border-radius: 10px;
    padding: 0 12px;
    height: 44px;
    min-width: 200px;
    transition: border-color 0.18s, box-shadow 0.18s;
}

.nch-gallery-search:focus-within {
    border-color: var(--page-accent, #1976d2);
    box-shadow: 0 0 0 3px rgba(25,118,210,0.1);
}

.nch-gallery-search__icon {
    color: var(--page-text-secondary, #9e9e9e);
    font-size: 0.875rem;
    margin-right: 8px;
    flex-shrink: 0;
}

.nch-gallery-search__input {
    background: transparent;
    border: none;
    outline: none;
    color: var(--page-text, #212121);
    font-size: 0.9rem;
    flex: 1;
    min-width: 0;
}

.nch-gallery-search__input::placeholder {
    color: var(--page-text-secondary, #9e9e9e);
}

.nch-gallery-search__clear {
    background: none;
    border: none;
    cursor: pointer;
    color: var(--page-text-secondary, #9e9e9e);
    padding: 0;
    margin-left: 4px;
    display: flex;
    align-items: center;
    font-size: 1rem;
    transition: color 0.15s;
}

.nch-gallery-search__clear:hover { color: var(--page-text, #212121); }

.nch-gallery-filters {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    flex: 1;
    min-width: 200px;
}

.nch-gallery-filter-chip {
    padding: 6px 14px;
    border-radius: 99px;
    border: 1.5px solid var(--page-border, #e0e0e0);
    background: transparent;
    color: var(--page-text, #424242);
    font-size: 0.8rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s, color 0.15s;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 6px;
}

.nch-gallery-filter-chip:hover {
    border-color: var(--page-accent, #1976d2);
    color: var(--page-accent, #1976d2);
}

.nch-gallery-filter-chip--active {
    background: var(--page-accent, #1976d2) !important;
    border-color: var(--page-accent, #1976d2) !important;
    color: var(--page-accent-text, #fff) !important;
}

.nch-gallery-filter-count {
    font-size: 0.7rem;
    opacity: 0.7;
    font-weight: 700;
}

.nch-gallery-filter-chip--active .nch-gallery-filter-count {
    opacity: 0.85;
}

@media (max-width: 600px) {
    .nch-gallery-toolbar { flex-direction: column; align-items: stretch; }
    .nch-gallery-search { width: 100%; }
    .nch-gallery-filters { width: 100%; }
}

.nch-gallery-section--spaced {
    margin-top: 2.5rem;
}

.nch-gallery-section__header {
    display: flex;
    align-items: baseline;
    gap: 10px;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 2px solid var(--page-border, #eeeeee);
}

.nch-gallery-section__title {
    font-size: 1.05rem;
    font-weight: 700;
    color: var(--page-text, #212121);
    letter-spacing: -0.01em;
}

.nch-gallery-section__count {
    font-size: 0.78rem;
    color: var(--page-text-secondary, #9e9e9e);
}

/* Grid */
.nch-gallery {
    display: grid;
    grid-template-columns: repeat(var(--cols, 3), 1fr);
    gap: var(--gallery-gap, 10px);
}

.nch-gallery__item {
    position: relative;
    overflow: hidden;
    border-radius: 6px;
    background: var(--page-surface, #f0f0f0);
}

.nch-gallery__media {
    position: relative;
    overflow: hidden;
    aspect-ratio: 1;
    background: var(--page-surface, #f0f0f0);
}

/* ── Card layout ── */
.nch-gallery--cards {
    align-items: start;
}

.nch-gallery__item--card {
    background: var(--page-surface, #fff);
    border: 1px solid var(--page-border, rgba(0,0,0,0.08));
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.06);
    transition: box-shadow 0.18s, transform 0.16s;
    display: flex;
    flex-direction: column;
}

.nch-gallery__item--card:hover {
    box-shadow: 0 6px 20px rgba(0,0,0,0.12);
    transform: translateY(-2px);
}

.nch-gallery__item--card .nch-gallery__media {
    aspect-ratio: 4 / 3;
    border-radius: 12px 12px 0 0;
}

.nch-gallery__caption {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 10px 12px 12px;
}

.nch-gallery__caption-name {
    font-size: 0.85rem;
    font-weight: 600;
    color: var(--page-text, #212121);
    line-height: 1.3;
    word-break: break-word;
}

.nch-gallery__caption-date {
    font-size: 0.72rem;
    color: var(--page-text-secondary, #9e9e9e);
    font-variant-numeric: tabular-nums;
}

/* Shimmer uses CSS vars for dark/light adaptation */
.nch-gallery__shimmer {
    position: absolute;
    inset: 0;
    background: linear-gradient(
        90deg,
        var(--page-surface, #ececec) 25%,
        var(--page-surface-hover, #e0e0e0) 50%,
        var(--page-surface, #ececec) 75%
    );
    background-size: 200% 100%;
    animation: nch-shimmer 1.5s infinite;
    transition: opacity 0.3s;
}

.nch-gallery__shimmer--done {
    opacity: 0;
    pointer-events: none;
}

@keyframes nch-shimmer {
    from { background-position: 200% 0; }
    to   { background-position: -200% 0; }
}

/* Lazy image */
.nch-gallery__img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0;
    transition: opacity 0.35s ease, transform 0.28s ease;
    will-change: transform;
}

.nch-gallery__img--loaded {
    opacity: 1;
}

.nch-gallery__item:hover .nch-gallery__img--loaded {
    transform: scale(1.05);
}

/* Load more */
.nch-gallery__load-more {
    margin-top: 20px;
    text-align: center;
}

.nch-gallery__load-btn {
    display: inline-flex;
    align-items: center;
    background: var(--page-surface, #fff);
    border: 1.5px solid var(--page-border, #e0e0e0);
    border-radius: 24px;
    padding: 9px 22px;
    font-size: 0.875rem;
    font-weight: 600;
    color: var(--page-text, #424242);
    cursor: pointer;
    transition: border-color 0.18s, box-shadow 0.18s, transform 0.14s;
}

.nch-gallery__load-btn:hover {
    background: var(--page-surface-hover, #f5f5f5);
    border-color: var(--page-text-secondary, #9e9e9e);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transform: translateY(-1px);
}

@media (max-width: 600px) {
    .nch-gallery { grid-template-columns: repeat(2, 1fr); }
}

/* Lightbox */
.nch-lightbox {
    position: fixed;
    inset: 0;
    background: rgba(10, 10, 10, 0.92);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
}

.nch-lb-enter-active, .nch-lb-leave-active {
    transition: opacity 0.25s ease, transform 0.25s ease;
}
.nch-lb-enter, .nch-lb-leave-to {
    opacity: 0;
    transform: scale(0.97);
}

.nch-lb-slide-enter-active, .nch-lb-slide-leave-active {
    transition: opacity 0.16s ease, transform 0.16s ease;
}
.nch-lb-slide-enter { opacity: 0; transform: scale(0.93); }
.nch-lb-slide-leave-to { opacity: 0; transform: scale(1.07); }

.nch-lightbox__img {
    max-width: 90vw;
    max-height: 82vh;
    object-fit: contain;
    border-radius: 4px;
    box-shadow: 0 24px 80px rgba(0, 0, 0, 0.5);
    display: block;
}

.nch-lightbox__close,
.nch-lightbox__nav {
    position: absolute;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.14);
    color: #fff;
    cursor: pointer;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s, transform 0.15s;
    padding: 0;
}

.nch-lightbox__close:hover,
.nch-lightbox__nav:hover { background: rgba(255, 255, 255, 0.2); }

.nch-lightbox__close { top: 16px; right: 16px; width: 40px; height: 40px; }
.nch-lightbox__close:hover { transform: scale(1.1); }

.nch-lightbox__nav { width: 44px; height: 44px; top: 50%; transform: translateY(-50%); }
.nch-lightbox__nav--prev { left: 16px; }
.nch-lightbox__nav--next { right: 16px; }
.nch-lightbox__nav--prev:hover { transform: translateY(-50%) translateX(-2px); }
.nch-lightbox__nav--next:hover { transform: translateY(-50%) translateX(2px); }

.nch-lightbox__meta {
    position: absolute;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    pointer-events: none;
}

.nch-lightbox__section-label {
    color: rgba(255, 255, 255, 0.75);
    font-size: 0.8rem;
    font-weight: 600;
    letter-spacing: 0.04em;
}

.nch-lightbox__counter {
    color: rgba(255, 255, 255, 0.45);
    font-size: 0.75rem;
    letter-spacing: 0.1em;
    font-variant-numeric: tabular-nums;
}

/* ── Gallery card mode ── */
.nch-gallery-cards {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 16px;
}
.nch-gallery-card {
    text-align: left;
    background: var(--page-surface, #fff);
    border: 1px solid var(--page-border, rgba(0,0,0,0.08));
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    padding: 0;
    transition: box-shadow 0.18s, transform 0.16s;
    display: flex;
    flex-direction: column;
}
.nch-gallery-card:hover { box-shadow: 0 6px 20px rgba(0,0,0,0.12); transform: translateY(-2px); }
.nch-gallery-card__cover {
    aspect-ratio: 4 / 3;
    background: var(--page-surface-hover, #e4e4e4);
    display: flex; align-items: center; justify-content: center;
    color: var(--page-text-secondary, #9e9e9e); font-size: 2rem;
}
.nch-gallery-card__cover img { width: 100%; height: 100%; object-fit: cover; }
.nch-gallery-card__body { padding: 10px 12px 12px; display: flex; flex-direction: column; gap: 2px; }
.nch-gallery-card__title { font-weight: 700; color: var(--page-text, #212121); }
.nch-gallery-card__count { font-size: 0.78rem; color: var(--page-text-secondary, #9e9e9e); }

.nch-gallery-modal {
    position: fixed; inset: 0; z-index: 9998;
    background: rgba(10,10,10,0.85);
    backdrop-filter: blur(4px);
    display: flex; align-items: center; justify-content: center; padding: 24px;
}
.nch-gallery-modal__panel {
    background: var(--page-bg, #fff);
    color: var(--page-text, #212121);
    border-radius: 14px;
    width: 100%; max-width: 1000px; max-height: 88vh;
    display: flex; flex-direction: column; overflow: hidden;
}
.nch-gallery-modal__header {
    display: flex; align-items: center; justify-content: space-between;
    padding: 14px 18px; border-bottom: 1px solid var(--page-border, rgba(0,0,0,0.1));
}
.nch-gallery-modal__title { font-weight: 700; font-size: 1.1rem; }
.nch-gallery-modal__close {
    background: none; border: none; cursor: pointer; font-size: 1.4rem;
    color: var(--page-text-secondary, #9e9e9e);
}
.nch-gallery-modal__filters { padding: 12px 18px; }
.nch-gallery-modal__body { padding: 0 18px 18px; overflow-y: auto; }
@media (max-width: 600px) {
    .nch-gallery-modal { padding: 0; }
    .nch-gallery-modal__panel { max-height: 100vh; border-radius: 0; }
}

/* ── Presencial Plans Cards ── */
.nch-filter-select-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
}
.nch-filter-select {
    appearance: none;
    background: var(--page-surface, #f5f5f5);
    color: var(--page-text, #212121);
    border: 1px solid var(--page-border, rgba(0,0,0,0.1));
    border-radius: 20px;
    padding: 6px 36px 6px 16px;
    font-size: 0.88rem;
    font-weight: 500;
    cursor: pointer;
    transition: border-color 0.18s, box-shadow 0.18s;
}
.nch-filter-select:focus {
    outline: none;
    border-color: var(--page-accent, #4caf50);
    box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.15);
}
.nch-select-arrow {
    position: absolute;
    right: 12px;
    pointer-events: none;
    color: var(--page-text-secondary, #9e9e9e);
    font-size: 1.1rem;
}

.nch-presencial-card {
    background: var(--page-surface, #fff);
    border: 1px solid var(--page-border, rgba(0,0,0,0.08));
    border-radius: 12px;
    overflow: hidden;
    transition: box-shadow 0.22s, transform 0.2s;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
.nch-presencial-card:hover {
    box-shadow: 0 8px 24px rgba(0,0,0,0.12);
    transform: translateY(-3px);
}
.nch-presencial-card__media {
    position: relative;
    aspect-ratio: 16 / 9;
    background: var(--page-surface-hover, #e4e4e4);
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}
.nch-presencial-card__img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s;
}
.nch-presencial-card:hover .nch-presencial-card__img {
    transform: scale(1.04);
}
.nch-presencial-card__placeholder {
    color: var(--page-text-secondary, #9e9e9e);
    font-size: 3rem;
}
.nch-presencial-card__badge {
    position: absolute;
    top: 12px;
    left: 12px;
    color: #fff;
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
    padding: 3px 8px;
    border-radius: 4px;
    letter-spacing: 0.05em;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
.nch-presencial-card__title {
    font-size: 1rem;
    font-weight: 700;
    color: var(--page-text, #212121);
    margin-bottom: 8px;
    line-height: 1.35;
}
.nch-presencial-card__desc {
    font-size: 0.85rem;
    line-height: 1.45;
    color: var(--page-text-secondary, #666);
    flex-grow: 1;
}
.nch-presencial-card__btn-photos {
    background: var(--page-accent, #4caf50);
    color: var(--page-accent-text, #fff);
    border: none;
    border-radius: 8px;
    padding: 8px 16px;
    font-size: 0.88rem;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: filter 0.15s, opacity 0.15s;
}
.nch-presencial-card__btn-photos:hover {
    filter: brightness(0.95);
}
</style>
